import { render, staticRenderFns } from "./AreaConfigurations.vue?vue&type=template&id=e2111530&scoped=true"
import script from "./AreaConfigurations.vue?vue&type=script&lang=js"
export * from "./AreaConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2111530",
  null
  
)

export default component.exports